// Network configuration
export const STARKNET_NETWORK = import.meta.env.VITE_STARKNET_NETWORK;
export const RPC_URL = import.meta.env.VITE_RPC_URL;

// Backend API
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Contract addresses
export const VAULT_ADDRESS = import.meta.env.VITE_VAULT_ADDRESS;
export const SETTLEMENT_ADDRESS = import.meta.env.VITE_SETTLEMENT_ADDRESS;
export const NOTE_REGISTRY_ADDRESS = import.meta.env.VITE_NOTE_REGISTRY_ADDRESS;

// Token constants (Sepolia MockERC20)
export const TOKENS = {
  USDC: {
    address: '0x065d73c998e853f3142314589e46a6e9ca031a40a861631897764718a815844c',
    symbol: 'USDC',
    name: 'USD Coin',
    decimals: 6,
  },
  BTC: {
    address: '0x002d2c46663f749e1ed423461a4a800acea6f2ac6f4b4ed762e39badf8ed70c9',
    symbol: 'BTC',
    name: 'Bitcoin',
    decimals: 8,
  },
  ETH: {
    address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
    symbol: 'ETH',
    name: 'Ethereum',
    decimals: 18,
  },
  STRK: {
    address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
    symbol: 'STRK',
    name: 'Starknet Token',
    decimals: 18,
  },
} as const;

export type TokenSymbol = keyof typeof TOKENS;

// Auction duration presets (in seconds)
export const DURATION_PRESETS = {
  bid: {
    '1h': 3600,
    '6h': 21600,
    '24h': 86400,
    '3d': 259200,
    '7d': 604800,
  },
  reveal: {
    '30m': 1800,
    '1h': 3600,
    '2h': 7200,
    '6h': 21600,
    '24h': 86400,
  },
} as const;

// App constants
export const APP_NAME = 'VB Desk';
export const APP_DESCRIPTION = 'Decentralized OTC Protocol on Starknet';

// Local storage keys
export const STORAGE_KEYS = {
  BIDS: 'vbdesk_bids',
  BID_PREFIX: 'vbdesk_bid_',
  BACKUP: 'vbdesk_backup',
  THEME: 'vbdesk_theme',
} as const;

// Query keys for TanStack Query
export const QUERY_KEYS = {
  auctions: ['auctions'] as const,
  auction: (id: string) => ['auction', id] as const,
  myBids: (address: string) => ['myBids', address] as const,
  protocolStats: ['protocolStats'] as const,
  tokenBalance: (address: string, token: string) => ['tokenBalance', address, token] as const,
  gasEstimate: (method: string) => ['gasEstimate', method] as const,
  batches: ['batches'] as const,
  batchStatus: (id: string) => ['batchStatus', id] as const,
  batchFills: (id: string) => ['batchFills', id] as const,
  receipt: (orderId: string) => ['receipt', orderId] as const,
  history: (wallet: string) => ['history', wallet] as const,
  notes: (wallet: string) => ['notes', wallet] as const,
  prices: ['prices'] as const,
} as const;

// Stale times for queries (in ms)
export const STALE_TIMES = {
  auctions: 30_000,
  auction: 30_000,
  myBids: 15_000,
  protocolStats: 60_000,
  tokenBalance: 10_000,
  gasEstimate: 30_000,
} as const;

// Animation durations (in ms)
export const ANIMATIONS = {
  fast: 150,
  normal: 300,
  slow: 500,
} as const;
